// Shared across every booking step so the title/back-button placement is identical everywhere
// and controlled from one place -- BookingFlow renders this once, above StepIndicator, instead
// of each step component rendering its own copy below it.
export default function StepHeader({
  title,
  onBack,
  backLabel,
  size = "compact",
}: {
  title: string;
  onBack?: () => void;
  backLabel?: string;
  size?: "compact" | "large";
}) {
  if (size === "large") {
    return <h1 className="font-display text-3xl">{title}</h1>;
  }
  return (
    <div className="relative flex items-center justify-center">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="absolute left-0 text-sm font-medium text-muted transition hover:text-foreground"
        >
          &larr; {backLabel}
        </button>
      )}
      <h1 className="font-display text-xl sm:text-2xl">{title}</h1>
    </div>
  );
}
